import { render } from "./SiteNoticePopup.vue?vue&type=template&id=39777908&scoped=true"
import script from "./SiteNoticePopup.vue?vue&type=script&lang=js"
export * from "./SiteNoticePopup.vue?vue&type=script&lang=js"

import "./SiteNoticePopup.vue?vue&type=style&index=0&id=39777908&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39777908"]])

export default __exports__